import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderProgressIndex from '../../../components/Admin/PlanBuilder/PlanBuilderProgressIndex';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderProgressIndexContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderProgressIndex {...props} />
  </ApolloProvider>
);

export default PlanBuilderProgressIndexContainer;



